import { Select, SelectProps } from '@mantine/core';
import { CompressionAndExport } from '@/app/workflows/actions/interfaces';

type CompressionMethod = NonNullable<CompressionAndExport['fileExports'][number]['meshCompressionMethod']>;
const options: { label: string; value: CompressionMethod }[] = [
  { label: 'None', value: 'none' },
  { label: 'Draco', value: 'draco' },
  { label: 'Draco Lossy', value: 'dracoLossy' },
];

export function CompressionSelect(props: SelectProps) {
  return <Select label='Compression' styles={{ label: { fontWeight: 600 } }} data={options} {...props} />;
}
